import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
/*import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';*/

@NgModule({
  imports: [
    NgbModule.forRoot()/*,
    CommonModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot()*/
  ],
  exports: [NgbModule/*,BsDropdownModule, TooltipModule, ModalModule*/]
})
export class AppBootstrapModule {}


// WEBPACK FOOTER //
// /Users/globant/site/src/app/app-bootstrap.module.ts